module.exports = __webpack_public_path__ + "img/delallo-white.6974e54d.png";